if (!customElements.get('legal-accordion-item')) {
  customElements.define('legal-accordion-item', class LegalAccordionItem extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.legal-accordion__trigger');
      this._handleClick = this._toggle.bind(this);
      this._trigger?.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      this._trigger?.removeEventListener('click', this._handleClick);
    }

    _toggle() {
      const isOpen = this.classList.toggle('is-open');
      this._trigger.setAttribute('aria-expanded', String(isOpen));
    }
  });
}
